export const SET_FIGURE_FILTER = "@FIGURES/SET_FIGURE_FILTER";
export const SET_HIDE_BLANKS = "@FIGURES/SET_HIDE_BLANKS";
